export const SERVICE_FETCH = {
  endpoint: '/availability',
  method: 'get',
  hostel: true,
};

// Calendário de preços/disponibilidade por dia (price calendar).
// Endpoint ainda a ser desenvolvido no backend — ver useRateCalendar (mock).
export const SERVICE_RATE_CALENDAR = {
  endpoint: '/rateCalendar',
  method: 'get',
  hostel: true,
};
